import { useState, useEffect, useMemo } from 'react';
import useAxios from 'axios-hooks';
import { camelCase } from 'lodash';

export const useEnum = () => {
  const [params, setParams] = useState();
  const [schemas, setSchemas] = useState();

  const [{ data, loading, error }, executeEnum] = useAxios(
    { url: 'enum-codes', params },
    { manual: true },
  );

  useEffect(() => {
    if (params) {
      executeEnum();
    }
  }, [params]);

  const getEnum = () => {
    setParams({
      schemaElementParent: [
        'AffiliationEligibility',
        'ActivityEligibility',
        'CollegeReadinessProgramParticipation',
        'ConditionCriteria',
        'EligibilityCriteria',
        'InterestCriteria',
        'MiscellaneousCriteria',
        'ProfessionCriteria',
        'SituationCriteria',
        'ProgramCategories',
        'Organization',
        'UnforeseenEventCriteria',
        'CitizenshipEligibility',
      ],
      typeList: 'model',
    });
  };

  useEffect(() => {
    if (!data) return;

    // Items listed here will be splitted up by schema element
    const requireSplit = ['Organization'];

    setSchemas(data.reduce((acc, { schemaElementParent, ...rest }) => {
      const group = camelCase(schemaElementParent);
      if (!acc[group]) acc[group] = [];
      if (requireSplit.includes(schemaElementParent)) {
        const { schemaElement, ...props } = rest;
        const subGroup = camelCase(rest.schemaElement);
        if (!acc[group][subGroup]) acc[group][subGroup] = [];
        acc[group][subGroup].push(props);
      } else {
        acc[group].push(rest);
      }
      return acc;
    }, {}));
  }, [data]);

  return useMemo(
    () => ({
      schemas,
      loadingEnum: loading,
      errorEnum: error,
      getEnum,
    }),
    [schemas, loading, error],
  );
};
